import { createSelector, createStructuredSelector } from 'reselect';
import { REQUEST_SENT } from '../../types';

export const contactDomain = () => state => state.root.contactWidgetReducer;
export const solutionsDomain = () => state => state.root.initialData.solutions;
export const bffDomain = () => state => state.Data;
export const translationsDomain = () => state => state.Data.translations;
export const reimbursementDomain = () => state => state.Data.reimbursementDetails;
export const rootDomain = () => state => state.root;

export const selectTeslaUrl = createSelector(
  bffDomain(),
  substate => substate.teslaUrl || ''
);

const selectIsEmailSent = createSelector(
  contactDomain(),
  subState => subState.isEmailSent
);

const selectIsDataRequestSent = createSelector(
  contactDomain(),
  subState => subState.dataRequestStatus === REQUEST_SENT
);

export const selectFirstName = createSelector(
  bffDomain(),
  subState => subState.firstName
);

export const selectLastName = createSelector(
  bffDomain(),
  subState => subState.lastName
);

export const selectShowSplashScreen = createSelector(
  bffDomain(),
  subState => subState.showContactUsSplash ?? false
);

export const selectPostalCode = createSelector(
  bffDomain(),
  subState => subState.postalCode ?? ''
);

export const selectUserEmail = createSelector(
  bffDomain(),
  subState => subState.emailAddress
);

const selectSolutionsData = createSelector(
  solutionsDomain(),
  subState => subState.data
);

const selectTranslations = createSelector(
  translationsDomain(),
  subState => subState.contact
);

const selectSolutionMappingTranslations = createSelector(
  translationsDomain(),
  subState => subState.solutionMapping
);

const selectCountry = createSelector(
  bffDomain(),
  subState => subState.CurrentCountry
);

export const selectLocale = createSelector(
  bffDomain(),
  subState => subState.locale
);

const selectShowReimbursementForm = createSelector(
  reimbursementDomain(),
  substate => (substate && substate.showReimbursementForm) ?? false
);

export const selectChatAvailabilityRequestStatus = createSelector(
  contactDomain(),
  subState => subState.chatAvailabilityRequestStatus
);

const selectDefaultContactNote = createSelector(
  contactDomain(),
  subState => subState.defaultContactNote
);

const selectUploadedFiles = createSelector(
  contactDomain(),
  subState => subState.files
);

export const selectTroubleshootingGuide = createSelector(
  contactDomain(),
  subState => subState.troubleshootingGuide
);

export const selectEnergySchedulingTeam = createSelector(
  contactDomain(),
  subState => subState.energySchedulingTeam
);

export const selectContactUsOverrides = createSelector(
  contactDomain(),
  subState => subState.troubleshootingSupportOverrides
);

export const selectIsEnergySupportedQueue = createSelector(
  contactDomain(),
  subState =>
    subState.firstChoice === 'energyProductSupport' ||
    (subState.firstChoice === 'vehicleCharging' && subState.secondChoice === 'homeCharging')
);

const selectChatWidgetParams = createSelector(
  contactDomain(),
  subState => subState.chatWidgetParams
);

const selectServiceMetricsResponseMap = createSelector(
  contactDomain(),
  subState => subState.serviceMetricsResponseMap
);

export default createStructuredSelector({
  isEmailSent: selectIsEmailSent,
  firstName: selectFirstName,
  lastName: selectLastName,
  postalCode: selectPostalCode,
  userEmail: selectUserEmail,
  solutionsData: selectSolutionsData,
  translations: selectTranslations,
  solutionMappingTranslations: selectSolutionMappingTranslations,
  country: selectCountry,
  isDataRequestSent: selectIsDataRequestSent,
  locale: selectLocale,
  showReimbursementForm: selectShowReimbursementForm,
  chatAvailabilityRequestStatus: selectChatAvailabilityRequestStatus,
  defaultContactNote: selectDefaultContactNote,
  uploadedFiles: selectUploadedFiles,
  chatWidgetParams: selectChatWidgetParams,
  serviceMetricsResponseMap: selectServiceMetricsResponseMap,
  troubleshootingGuide: selectTroubleshootingGuide,
  contactUsOverrides: selectContactUsOverrides,
  isEnergySupportedQueue: selectIsEnergySupportedQueue,
  showSplashScreen: selectShowSplashScreen,
});
